import React, {Component} from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../pages/home';
import Blog from '../pages/blog';
import BlogDetails from '../pages/blog-details';
import Gallery from '../pages/gallery';
import GalleryDetails from '../pages/gallery-details';
import ContactUs from '../pages/contact-us';
import AboutUs from '../pages/about-us';

class PageContent extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" exact component={Home}/>
        <Route path="/blog" exact component={Blog}/>
        <Route path="/blog/:articleId" component={BlogDetails}/>
        <Route path="/gallery" exact component={Gallery}/>
        <Route path="/gallery/:articleId" component={GalleryDetails}/>
        <Route path="/contact-us" exact component={ContactUs}/>
        <Route path="/about-us" exact component={AboutUs}/>
      </Switch>
    );
  }
}

export default PageContent;